import { create } from 'zustand';
import { toApiError } from '@/api/errors';

interface Notification {
  id: number;
  severity: 'success' | 'info' | 'warning' | 'error';
  /** i18n key (ns:key) or ready-made text */
  message: string;
  requestId?: string;
}

interface NotificationState {
  current: Notification | null;
  show: (n: Omit<Notification, 'id'>) => void;
  dismiss: () => void;
}

export const useNotifications = create<NotificationState>((set) => ({
  current: null,
  show: (n) => set({ current: { ...n, id: Date.now() } }),
  dismiss: () => set({ current: null }),
}));

/** Imperative API usable outside React (query cache, interceptors). */
export const notify = {
  success: (messageKey: string) => useNotifications.getState().show({ severity: 'success', message: messageKey }),
  error: (error: unknown) => {
    const e = toApiError(error);
    useNotifications.getState().show({ severity: 'error', message: `errors:${e.code}`, requestId: e.requestId });
  },
};

